import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FastForwardOpkraevningsdateDialogData } from '../../../models';

@Component({
    selector: 'app-fast-forward-opkraevningsdate-dialog',
    templateUrl: './fast-forward-opkraevningsdate-dialog.component.html',
    styleUrls: ['./fast-forward-opkraevningsdate-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FastForwardOpkraevningsdateDialogComponent implements OnInit {
  form: UntypedFormGroup;
  intervalStart: Date;
  intervalEnd: Date;
  agreementEndsInterval: boolean;

  get causeRemark() {
    return this.form.get('causeRemark');
  }

  constructor(
    private fb: UntypedFormBuilder,
    private dialog: MatDialogRef<FastForwardOpkraevningsdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FastForwardOpkraevningsdateDialogData
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      causeRemark: [null, [Validators.required]],
    });

    this.intervalStart = this.data.intervalStartDate;
    this.intervalEnd = this.data.intervalEndDate;
    this.agreementEndsInterval = this.data.endDateInInterval;
  }

  save() {
    this.dialog.close(this.causeRemark.value);
  }

  cancel() {
    this.dialog.close(null);
  }
}
